<template>
  <Modal class="modal" :closable="false">
    <p>Награда появится в вашем профиле в течение недели</p>
  </Modal>
</template>

<script>
import Modal from "./Modal";

export default {
  components: { Modal },
  methods: {
    close() {
      this.$store.commit("toggleModal", "formSend");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal__inner {
  font-size: 18px;
  font-weight: 700;
  max-width: 400px;
}
</style>
